import { defineMessages } from "react-intl"

export const priceConfirmationModalMessages = defineMessages({
	vehiclePriceLowHeadline: {
		defaultMessage: "Confirm low vehicle price",
		id: "priceConfirmationModal.headline",
	},
	vehiclePriceLowLabel: {
		defaultMessage:
			"The vehicle price of <b>{price}</b> seems unusually low. " +
			"Are you sure you want to make the vehicle visible to customers with a price of <b>{price}</b>?",
		id: "priceConfirmationModal.label",
	},

	salesPriceLowHeadline: {
		defaultMessage: "Confirm low sales price",
		id: "priceConfirmationModal.sales.lowPrice.headline",
	},
	salesPriceLowLabel: {
		defaultMessage:
			"The sales price of <b>{price}</b> seems unusually low. " +
			"Are you sure you want to set the sales price to <b>{price}</b>?",
		id: "priceConfirmationModal.sales.lowPrice.label",
	},

	salesPriceHighHeadline: {
		defaultMessage: "Confirm high sales price",
		id: "priceConfirmationModal.sales.highPrice.headline",
	},
	salesPriceHighLabel: {
		defaultMessage:
			"The sales price of <b>{price}</b> seems unusually high. " +
			"Are you sure you want to set the sales price to <b>{price}</b>?",
		id: "priceConfirmationModal.sales.highPrice.label",
	},

	button: {
		defaultMessage: "Confirm price",
		id: "priceConfirmationModal.confirm.button.label",
	},
})
